/**
 * Application response parser utility
 * Handles both old format (array of applications) and new format (object with applications and deleted_applications_count)
 */

export interface ApplicationResponseOld {
  applications: any[]
}

export interface ApplicationResponseNew {
  applications: any[]
  deleted_applications_count: number
}

export interface ParsedApplicationResponse {
  applications: any[]
  deletedApplicationsCount: number
}

/**
 * Parses application response to handle both backward compatible formats
 * @param response - The API response which can be an array or an object
 * @returns Parsed response with applications array and deleted count
 */
export const parseApplicationResponse = (
  response: any,
): ParsedApplicationResponse => {
  // Handle old format (array of applications)
  if (Array.isArray(response)) {
    return {
      applications: response,
      deletedApplicationsCount: 0,
    }
  }

  // Handle new format (object with applications and deleted_applications_count)
  if (response && typeof response === 'object') {
    return {
      applications: response.applications || [],
      deletedApplicationsCount: response.deleted_applications_count || 0,
    }
  }

  // Fallback for unexpected formats
  return {
    applications: [],
    deletedApplicationsCount: 0,
  }
}

export default parseApplicationResponse
